// extracted by mini-css-extract-plugin
export default {"note":"ActivityNotePreview_note__QRexd"};